/* RESPONSIBLE TEAM: team-tickets-1 */
import { isEmpty } from '@ember/utils';

let orderNameRegex = /^#?[0-9]+$/;

export function isValidOrderName(orderName) {
  return isEmpty(orderName) ? false : orderNameRegex.test(orderName);
}
